import * as React from 'react';
import { Stack } from '@mui/material';
import { dateFormat } from '../../../utilis/date-formats';

export default function SelectedDateContainer({ queryFilters, isMobile }) {
    return (
        <Stack item direction={"row"} alignItems="center" sx={{ 
            mr: 3,
            ...(isMobile && {
                fontSize: "10px",                
            })
         }}>
            <span className={isMobile ? "ffmar-reg" : "ffmar-bold"} style={{
                ...(isMobile && {                
                    fontSize: "10px",
                }),
            }}>Selected Date:&nbsp;</span>
            {dateFormat(queryFilters?.startDate, "MM/DD/YYYY")} -{" "}
            {dateFormat(queryFilters?.endDate, "MM/DD/YYYY")}
        </Stack>
    );
}
